import log from "loglevel";
import { sharedEnvironment } from "@akina/config";
import { errorTrackingService } from "./errorTrackingService";

const boldAndRed = "font-weight: bold; color: red;";
const boldAndOrange = "font-weight: bold; color: orange;";
const boldAndGreen = "font-weight: bold; color: green;";
const boldAndLightBlue = "font-weight: bold; color: lightblue;";

const getLogLevel = (): log.LogLevelDesc => {
  const envLogLevel = import.meta.env.VITE_LOG_LEVEL;

  if (envLogLevel) {
    // Validate that the log level is supported by loglevel
    const validLevels: log.LogLevelDesc[] = ["trace", "debug", "info", "warn", "error", "silent"];
    if (validLevels.includes(envLogLevel as log.LogLevelDesc)) {
      return envLogLevel as log.LogLevelDesc;
    }
  }

  // if not specified, silent in produciton and debug elsewhere
  return sharedEnvironment.environment === "prod" ? "silent" : "info";
};

const configureLogger = (logLevel: log.LogLevelDesc, notifier: (...params: unknown[]) => void) => {
  log.setLevel(logLevel);

  const loggerService = {
    debug: (...params: unknown[]) => {
      log.debug(`%c[DEBUG]`, boldAndLightBlue, ...params);
    },
    info: (...params: unknown[]) => {
      log.info(`%c[INFO]`, boldAndGreen, ...params);
    },
    warn: (...params: unknown[]) => {
      log.warn(`%c[WARN]`, boldAndOrange, ...params);
    },
    error: (...params: unknown[]) => {
      log.error(`%c[ERROR]`, boldAndRed, ...params);
      notifier(...params);
    },
  };

  return loggerService;
};

export const loggerService = configureLogger(getLogLevel(), (...params: unknown[]) => {
  if (sharedEnvironment.environment !== "dev") {
    const errorObj = (params.find(param => param instanceof Error) as Error) || undefined;
    const contextParts = params.filter(param => !(param instanceof Error));
    const contextMessage = contextParts.join(" ");

    if (errorObj) {
      // Preserve the Error object with its stack trace
      errorObj.name = `${errorObj.name}: ${contextMessage}`;
      errorObj.message = `${errorObj.message}. ${contextMessage}.`;
      errorTrackingService.captureException(errorObj);
    } else {
      errorTrackingService.captureException(new Error(params.join(" ")));
    }
  }
});
